import React from 'react'

export default function About(props) {
  return (
    <>
    <div className="container about" id='about' >
    <div className="accordion accordion-flush" id="accordionFlushExample" >
    <div className="accordion-item py-2" style={{color:props.mode==="dark"?'white':'black',backgroundColor:props.mode==="dark"?'#030e12':'white'  }}>
    <h2 className="accordion-header" id="flush-headingOne" style={{color:props.mode==="dark"?'white':'black',backgroundColor:props.mode==="dark"?'black':'white'}}>
      <button className="accordion-button collapsed" id="btnwohwala"type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne" style={{color:props.mode==="dark"?'white':'black',backgroundColor:props.mode==="dark"?'#030e12':'white'}} >
        About
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample" style={{color:props.mode==="dark"?'white':'black',backgroundColor:props.mode==="dark"?'#030e12':'white'}}>
      <div className="accordion-body" > Text Changer is a Text Utility Application where you can modify your text like conver them to upper-case,lower-case with time we'll be adding more Utilities like remove Spaces,change Text-fonts,convert to another Language etc.</div>
    </div> 
    </div>
    <div className="accordion-item py-2" style={{color:props.mode==="dark"?'white':'black',backgroundColor:props.mode==="dark"?'#030e12':'white'  }} >
    <h2 className="accordion-header" id="flush-headingtwo" >
      <button className="accordion-button collapsed" id="btnwohwala2"type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo" style={{color:props.mode==="dark"?'white':'black',backgroundColor:props.mode==="dark"?'#030e12':'white'}} >
        Motive
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample" style={{color:props.mode==="dark"?'white':'black',backgroundColor:props.mode==="dark"?'#030e12':'white'}}>
      <div className="accordion-body" >
        Our Motive is to create open Source free to use Apllications without ads surfing and malware to our Website .we'll
        Make sure of your Data to keep it safe and Untouch.
      </div>
      </div> 
  </div>
 </div>  
 </div>

    </>
  )
}
